import React from 'react';
import { Grid } from '@material-ui/core';
import { SearchResult } from '../../../types/api';
import Paper, { PaperAuthorizationProps } from '../../../elements/Paper';
import { getMrns } from '../../../utils/AccountDetailsUtil';
import { CardType } from '../../../types/cardTypes';

type LinkedRecordComponentProps = {
    openRemovalModal: any;
    linkedRecord: SearchResult;
    verifiedWith: string;
} & PaperAuthorizationProps;

function LinkedRecordComponent({ linkedRecord, openRemovalModal, verifiedWith, onAuthorize, isAuthorizing, onAuthorizing }: LinkedRecordComponentProps) {
    return (
        <>
            <Grid
                container
                direction='row'
                style={{ width: '460px' }}
            >
                <Paper
                    variant='outlined'
                    cardType={CardType.LinkedCard}
                    onUnlink={openRemovalModal}
                    onAuthorize={onAuthorize}
                    isAuthorizing={isAuthorizing}
                    onAuthorizing={onAuthorizing}
                    inputData={linkedRecord}
                    verifiedWith={verifiedWith}
                    mrns={getMrns([linkedRecord])}
                />
            </Grid>
        </>
    );
}

export default LinkedRecordComponent;
